<template>
  <p
    class="tw:m-0! tw:rounded-sm tw:border tw:border-solid tw:border-gray-200 tw:bg-gray-50 tw:p-3 tw:text-center tw:text-13 tw:text-gray-500">
    <slot />
  </p>
</template>
